import { StyleSheet, View } from 'react-native';
import { useSelector } from 'react-redux';
import { NODE_ENV } from '@env';
import { DrawerContentScrollView } from '@react-navigation/drawer';
import { StackActions } from '@react-navigation/native';
import { Text } from '@ui-kitten/components';
import PropTypes from 'prop-types';

import routeList from '../Routes/list';
import { selectPage } from '../RTK/utility/selectors';
import ThemeColor from '../Theme/colors';
import ThemeStyle from '../Theme/styles';

import Button from './Button';
import VersionText from './VersionText';
import CloseButton from './Web/CloseButton';

const LeftDrawerContent = ({ data, navigation, children }) => {
  const page = useSelector(selectPage);

  const isDevelopment = NODE_ENV === 'development';

  const toggleDrawer = () => navigation.getParent('LeftDrawer').closeDrawer();
  const onPress = (item) => {
    navigation.dispatch(
      StackActions.replace(routeList.HOME, {
        screen: 'MainMenu',
        params: {
          screen: item.value,
          params: item.params,
        },
      }),
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.closeButtonContainer}>
        <CloseButton onPress={toggleDrawer} />
      </View>
      <DrawerContentScrollView style={styles.drawerContentScrollview}>
        {data?.map((item, index) => {
          const { SideBarIcon, onPressItem, text, value } = item;
          const isReservation =
            page.isReservation && value === routeList.RESERVATION_TAB;
          const isSelected = isReservation || page.name === value;
          const color = isSelected ? ThemeColor.green : ThemeColor.black;
          return (
            <Button
              key={index}
              testID="menu_btn"
              status="success"
              onPress={() => (!onPressItem ? onPress(item) : onPressItem())}
              style={styles.drawerItem}
              plain
            >
              <View style={{ width: '15%' }}>
                <SideBarIcon color={color} />
              </View>
              <View>
                <Text style={{ color }}>{text}</Text>
              </View>
            </Button>
          );
        })}

        {children}
      </DrawerContentScrollView>
      <View
        style={[ThemeStyle.appVersionContainer, ThemeStyle.spacingBottomMedium]}
      >
        {isDevelopment && <VersionText />}
      </View>
    </View>
  );
};
LeftDrawerContent.propTypes = {
  //string to be displayed at the top of drawer.
  title: PropTypes.string,

  //data to be rendered in drawer component.
  data: PropTypes.array,

  //props for navigation provided by react-navigation.
  navigation: PropTypes.any,

  //it allow to render element body inside the drawer component.
  children: PropTypes.element,
};

const styles = StyleSheet.create({
  container: { flex: 1, height: '100%' },
  closeButtonContainer: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    ...ThemeStyle.spacingTopMedium,
    ...ThemeStyle.pageHorizontalSpacingSmall,
  },
  drawerContentScrollview: { paddingLeft: '5%' },
  drawerItem: {
    borderBottomWidth: 1,
    borderBottomColor: ThemeColor.lightGray,
    width: '90%',
    height: 50,
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});

export default LeftDrawerContent;
